import React, { useState } from 'react';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';
import SlidingPane from 'react-sliding-pane';
import SteamBulkRequest from '../../requests/slideout/SteamBulkRequest';
import { toast } from 'react-toastify';
import { populateSkuKeyPools } from '../../../util/steamUtils';
import icons from '../../../constants/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export interface GameBulkActionsProps {
  done: () => void;
  cancel: () => void;
  items: any[];
}

function GameBulkActions({ done, cancel, items }: GameBulkActionsProps) {
  const { t } = useTranslation();
  const [bulkSteamRequestSlideoutOpen, setBulkSteamRequestSlideoutOpen] =
    useState(false);
  const [bulkSteamRequestSlideoutSKUs, setBulkSteamRequestSlideoutSKUs] =
    useState<any>();

  const handleSteamBulkRequest = async (e: any) => {
    e.cancelBubble = true;
    const skus = await populateSkuKeyPools(
      items.map((x: any) => {
        return { gameId: x.gameId, gameName: x.gameName, skus: x.skuIds };
      })
    );
    if (skus.length > 0) {
      setBulkSteamRequestSlideoutSKUs(skus);
      setBulkSteamRequestSlideoutOpen(true);
    } else {
      toast.error(
        t(
          'None of the selected SKUs support key pools or the workflow is missing key provider reference'
        )
      );
    }
    return false;
  };

  const BulkActionItem = ({ title, description, icon, onClick }: any) => (
    <div
      className="col-sm-12 template p-0 bulk action-update"
      style={{ cursor: 'pointer' }}
      onClick={onClick}
    >
      <div className="template-detail p-4">
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
      <div className="icon-wrapper">
        <FontAwesomeIcon icon={icon} />
      </div>
    </div>
  );
  return (
    <>
      <SlideoutLayout title={t('Bulk actions')} cancel={cancel}>
        <BulkActionItem
          title={t('Request on Steam')}
          description={t('Send an automated request to Steam')}
          icon={icons.REQUEST_ON_STEAM}
          onClick={handleSteamBulkRequest}
        ></BulkActionItem>
      </SlideoutLayout>
      <SlidingPane
        isOpen={bulkSteamRequestSlideoutOpen}
        hideHeader={true}
        from="right"
        className="large-side-panel"
        onRequestClose={() => setBulkSteamRequestSlideoutOpen(false)}
      >
        <SteamBulkRequest
          done={() => {
            setBulkSteamRequestSlideoutSKUs(null);
            done();
          }}
          cancel={() => setBulkSteamRequestSlideoutOpen(false)}
          skus={bulkSteamRequestSlideoutSKUs}
          gameName={""}
        ></SteamBulkRequest>
      </SlidingPane>
    </>
  );
}

export default GameBulkActions;
